import axios from 'axios';
import {VehicleStateModel} from "@/models/VehicleState";
import {DriverDetail} from "@/models/DriverView";

const BASE_URL = '/'; // replace with your backend
//const BASE_URL = 'http://localhost:5208/'; // replace with your backend

function mapCodeToState(code) {
    switch (code) {
        case 'DS_D':   return { state: 'driving', statusShort: 'D'   }; // Driving
        case 'DS_ON':  return { state: 'online',  statusShort: 'ON'  }; // On Duty
        case 'DS_OFF': return { state: 'offline', statusShort: 'OFF' }; // Off Duty
        case 'DS_SB':  return { state: 'idle',    statusShort: 'SB'  }; // Sleeper berth
        default:       return { state: 'online',  statusShort: 'ON'  };
    }
}

function relativeTimeFromNow(iso) {
    try {
        const then = new Date(iso);
        if (isNaN(then.getTime())) return iso; // invalid date → fallback

        const now = new Date();
        const diffSec = Math.floor((now - then) / 1000);

        if (diffSec < 5) {
            return "just now";
        }
        if (diffSec < 60) {
            return `${diffSec} sec${diffSec > 1 ? "s" : ""} ago`;
        }

        const diffMin = Math.floor(diffSec / 60);
        if (diffMin < 60) {
            return `${diffMin} min${diffMin > 1 ? "s" : ""} ago`;
        }

        const diffHr = Math.floor(diffMin / 60);
        if (diffHr < 24) {
            return `${diffHr} hour${diffHr > 1 ? "s" : ""} ago`;
        }

        const diffDay = Math.floor(diffHr / 24);
        return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
    } catch {
        return iso;
    }
}

export async function fetchTrucks(companyId) {
    const res = await axios.get(`${BASE_URL}main/vehicles-infos/${companyId}`);
    const json = res.data;

    if (!json?.isSuccess) {
        throw new Error(json?.errorMessage || 'API returned isSuccess=false');
    }

    return (json.data || []).map(x => {
        const { state, statusShort } = mapCodeToState(x.code);
        return {
            id: x.vehicleId || x.id,
            driverId: x.accountId,
            number: String(x.name ?? ''),
            speed: Number(((x.speed ?? 0) * 0.621371).toFixed(0)),
            state,
            location: x.locationText || '',
            lastSeen: relativeTimeFromNow(x.lastSeen),
            statusShort,
            driver: x.fullName || '',
            liveShareLink: x.liveLocationShareLink || '',
        };
    });
}

export async function fetchVehicleState(vehicleId) {
    const res = await axios.get(`${BASE_URL}main/vehicle-state/${vehicleId}`);
    const json = res.data;

    if (!json?.isSuccess) {
        throw new Error(json?.errorMessage || 'API returned isSuccess=false');
    }

    return new VehicleStateModel(json.data);
}

export async function driverViewById(driverId) {
    const res = await axios.get(`${BASE_URL}main/driver-view/${driverId}`);
    const json = res.data;

    if (!json?.isSuccess) {
        throw new Error(json?.errorMessage || 'API returned isSuccess=false');
    }

    return new DriverDetail(json.data);
}
